

import { db } from "../../config/firebase";
import { collection, addDoc, getDoc, query, where, getDocs, doc, deleteDoc, updateDoc, Timestamp, arrayUnion, orderBy } from 'firebase/firestore'
import { storage } from "../../config/firebase";
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'



const createBusiness = async (businessData, userId) => {

    const businessAllData = {
        businessId: "",
        creatorId: userId,
        id: "",
        businessName: "",
        businessLocation: "",
        businessPhone: "",
        about: "",
        sector: "",
        sectors: [],
        businessSize: "",
        businessType: "",
        businessCategory: "",
        pricingDate: Timestamp.now(),
        pricingState: false,
        createDate: Timestamp.now(),
        businessState: true,
        businessMail: "",
        logo: " ",
        webSite: "",
        thumbnail: "",
        status: true,
        state: true,
        blackList: [],
        users: [userId],
        admin: [userId],
        //image: _image!.path.toString(),
        image: "",
        invitations: [],
        interests: [],
        userInvite: [],
        files: [],
        follower: [],
        meetings: [],
        messageBox: [],
        social: {
            facebook: '',
            instagram: '',
            linkedin: '',
            twitter: '',
            youtube: '',
        },
        notifications: [],
        sessions: [],
        tags: [],
    };

    const colRef = await collection(db, 'business');
    const docRef = await addDoc(colRef, {
        ...businessAllData,
    })
    const docSnap = await getDoc(docRef);
    console.log("docSnap.id: " + docSnap.id);
    // Set id fields on business document
    const docRefU = await doc(db, 'business', docSnap.id);
    await updateDoc(docRefU, { businessId: docSnap.id, id: docSnap.id })
    // Also link the business to the user document for future lookups
    const userDocRef = await doc(db, 'users', userId);
    try {
        await updateDoc(userDocRef, { businessId: docSnap.id });
    } catch (e) {
        // If user doc does not exist or update fails, we still return the business
        console.warn('Unable to set user.businessId', e);
    }
    return { ...docSnap.data(), businessId: docSnap.id };
}

const getBusiness = async (businessId) => {
    // For compatibility; fetch user's business if available

    const bizRef = await doc(db, 'business', businessId);
    const bizSnap = await getDoc(bizRef);
    if (bizSnap.exists()) {
        return { ...bizSnap.data(), id: bizSnap.id };
    }
    return null;
}

const getMyBusiness = async (userId) => {
    // First, read the user to determine businessId
    const userRef = await doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) return null;

    const businessId = userSnap.data()?.businessId;

    // If user already has a business, fetch and return it
    if (businessId && String(businessId).trim() !== '') {
        const bizRef = await doc(db, 'business', businessId);
        const bizSnap = await getDoc(bizRef);
        if (bizSnap.exists()) {
            return { ...bizSnap.data(), id: bizSnap.id };
        }
        return null;
    }

    // Otherwise, create a new business and link it to the user
    const created = await createBusiness({}, userId);
    return created;
}

const updateMyBusiness = async (profileData, userId) => {
    // Update the business document that belongs to this user
    const userRef = await doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) return null;
    const businessId = userSnap.data()?.businessId;
    if (!businessId) return null;
    const bizRef = await doc(db, 'business', businessId);
    await updateDoc(bizRef, profileData);
    const bizSnap = await getDoc(bizRef);
    return { ...bizSnap.data(), id: bizSnap.id };
}

// Uploads a PDF catalog to storage and updates business document with its URL
const uploadBusinessCatalog = async (file, userId) => {
    if (!file) throw new Error('No file provided');

    // Ensure user has a business
    const userRef = await doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) return null;
    let businessId = userSnap.data()?.businessId;
    if (!businessId || String(businessId).trim() === '') {
        const created = await createBusiness({}, userId);
        businessId = created.businessId || created.id;
    }

    // Upload to storage
    const catalogPath = `business/${businessId}/catalog.pdf`;
    const catalogRef = ref(storage, catalogPath);
    await uploadBytes(catalogRef, file, { contentType: 'application/pdf' });
    const url = await getDownloadURL(catalogRef);

    // Update business doc
    const bizRef = await doc(db, 'business', businessId);
    await updateDoc(bizRef, { catalogUrl: url, catalogUpdatedAt: Timestamp.now() });
    const bizSnap = await getDoc(bizRef);
    return { ...bizSnap.data(), id: bizSnap.id };
}

// Uploads an image thumbnail (logo) to storage and updates business document with its URL
const uploadBusinessThumbnail = async (file, userId) => {
    if (!file) throw new Error('No file provided');

    // Ensure user has a business
    const userRef = await doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) return null;
    let businessId = userSnap.data()?.businessId;
    if (!businessId || String(businessId).trim() === '') {
        const created = await createBusiness({}, userId);
        businessId = created.businessId || created.id;
    }

    // Derive a stable path; overwrite to keep single URL
    const thumbPath = `business/${businessId}/thumbnail`;
    const thumbRef = ref(storage, thumbPath);
    const contentType = file.type && file.type.startsWith('image/') ? file.type : 'image/jpeg';
    await uploadBytes(thumbRef, file, { contentType });
    const url = await getDownloadURL(thumbRef);

    // Update business doc
    const bizRef = await doc(db, 'business', businessId);
    await updateDoc(bizRef, { thumbnail: url, thumbnailUpdatedAt: Timestamp.now() });
    const bizSnap = await getDoc(bizRef);
    return { ...bizSnap.data(), id: bizSnap.id };
}

const listBusinesses = async () => {
    try {
        const colRef = collection(db, 'business');
        const q = query(colRef, orderBy('createdAt', 'desc'));
        let querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
            const fallback = query(colRef, orderBy('createDate', 'desc'));
            querySnapshot = await getDocs(fallback);
        }
        return querySnapshot.docs.map((docSnap) => {
            const data = docSnap.data();
            return normalizeBusiness({ ...data, id: docSnap.id });
        });
    } catch (error) {
        throw buildServiceError(error, 'Firmalar yüklenemedi.');
    }
};

const updateBusinessActive = async (id, businessState) => {
    try {
        const docRef = doc(db, 'business', id);
        await updateDoc(docRef, {
            businessState,
            updatedAt: Timestamp.now(),
        });
        const docSnap = await getDoc(docRef);
        return normalizeBusiness({ ...docSnap.data(), id: docSnap.id });
    } catch (error) {
        throw buildServiceError(error, 'Firma durumu güncellenemedi.');
    }
};

const updateBusinessById = async (id, data) => {
    try {
        const docRef = doc(db, 'business', id);
        await updateDoc(docRef, {
            ...data,
            updatedAt: Timestamp.now(),
        });
        const docSnap = await getDoc(docRef);
        return normalizeBusiness({ ...docSnap.data(), id: docSnap.id });
    } catch (error) {
        throw buildServiceError(error, 'Firma güncellenemedi.');
    }
};

const deleteBusinessById = async (id) => {
    try {
        const docRef = doc(db, 'business', id);
        await deleteDoc(docRef);
        return { id };
    } catch (error) {
        throw buildServiceError(error, 'Firma silinemedi.');
    }
};

const updateBusinessUsers = async (id, users) => {
    try {
        const docRef = doc(db, 'business', id);
        await updateDoc(docRef, {
            users: Array.isArray(users) ? users : [],
            updatedAt: Timestamp.now(),
        });
        const docSnap = await getDoc(docRef);
        return normalizeBusiness({ ...docSnap.data(), id: docSnap.id });
    } catch (error) {
        throw buildServiceError(error, 'Firma kullanıcıları güncellenemedi.');
    }
};

const createBusinessByAdmin = async ({ businessName, businessMail, businessState }) => {
    try {
        const businessAllData = {
            businessId: "",
            creatorId: "",
            id: "",
            businessName: businessName || "",
            businessLocation: "",
            businessPhone: "",
            about: "",
            sector: "",
            sectors: [],
            businessSize: "",
            businessType: "",
            businessCategory: "",
            pricingDate: Timestamp.now(),
            pricingState: false,
            createDate: Timestamp.now(),
            businessState: typeof businessState === 'boolean' ? businessState : true,
            businessMail: businessMail || "",
            logo: " ",
            webSite: "",
            thumbnail: "",
            status: true,
            state: true,
            blackList: [],
            users: [],
            admin: [],
            image: "",
            invitations: [],
            interests: [],
            userInvite: [],
            files: [],
            follower: [],
            meetings: [],
            messageBox: [],
            social: {
                facebook: '',
                instagram: '',
                linkedin: '',
                twitter: '',
                youtube: '',
            },
            notifications: [],
            sessions: [],
            tags: [],
        };

        const colRef = collection(db, 'business');
        const docRef = await addDoc(colRef, { ...businessAllData });
        const docSnap = await getDoc(docRef);
        const docRefU = doc(db, 'business', docSnap.id);
        await updateDoc(docRefU, { businessId: docSnap.id, id: docSnap.id });
        return normalizeBusiness({ ...docSnap.data(), id: docSnap.id, businessId: docSnap.id });
    } catch (error) {
        throw buildServiceError(error, 'Firma oluşturulamadı.');
    }
};

const businessService = {
    createBusiness,
    getBusiness,
    getMyBusiness,
    updateMyBusiness,
    uploadBusinessCatalog,
    uploadBusinessThumbnail,
    listBusinesses,
    updateBusinessActive,
    updateBusinessById,
    deleteBusinessById,
    createBusinessByAdmin,
    updateBusinessUsers,
}

export default businessService
const toMillis = (value) => {
    if (!value) return value;
    if (typeof value === 'number') return value;
    if (typeof value?.toDate === 'function') return value.toDate().getTime();
    if (typeof value?.seconds === 'number') return value.seconds * 1000;
    return value;
};

const normalizeBusiness = (biz) => {
    if (!biz) return biz;
    const createdAt = biz.createdAt || biz.createDate;
    return {
        ...biz,
        createdAt: toMillis(createdAt),
        updatedAt: toMillis(biz.updatedAt),
        createDate: toMillis(biz.createDate),
    };
};

const buildServiceError = (error, fallbackMessage) => {
    return {
        message: error?.message || fallbackMessage || 'Beklenmeyen bir hata oluştu.',
        code: error?.code || 'UNKNOWN_ERROR',
    };
};
